import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import RenderViewConsents from '../RenderViewConsents';
import { selectUserPaperConsents } from '../../../../redux/profiles/selectors';

import styles from './index.styl';

const PaperConsents = ({ formatMessage }) => {
  const paperConsents = useSelector(selectUserPaperConsents);
  const hasPaperConsents = Boolean(paperConsents.length);

  return (
    <div className={styles.wrapper}>
      <span className={styles.sectionTitle}>
        {formatMessage({ id: 'documentation.paperConsents.title' })}
      </span>

      {hasPaperConsents ? (
        <div className={styles.content}>
          <RenderViewConsents
            consentsList={paperConsents}
            formatMessage={formatMessage}
          />
        </div>
      ) : (
        <div>-</div>
      )}
    </div>
  );
};

PaperConsents.propTypes = {
  formatMessage: PropTypes.func,
};

export default PaperConsents;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/PaperConsents/index.jsx